import {ApiUrl} from "../../../auth/authMethods";
import React, {useState} from "react";
import PersonIcon from "@mui/icons-material/Person";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import PopupEdit from "../../../component/PopupEdit/PopupEdit";
import Select from "react-select";
import {DatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {handleChangeData} from "../../../utils/handleChangeData";
import CloseIcon from '@mui/icons-material/Close';

const statusNegativacaoList = [
    {value: 'EM_NEGATIVACAO', label: 'Em negativação'},
    {value: 'NEGATIVADO', label: 'Negativado'},
    {value: 'NEGATIVACAO_CANCELADA', label: 'Negativação Cancelada'},
    {value: 'REJEITADO', label: 'Rejeitado'},
    {value: 'NAO_EXECUTADA', label: 'Não executada'},
]

export default function PopupEditNegativationData({item, setLoadData}) {

    const baseUrl = `${ApiUrl}/boletos/negativation`

    const [dataNegativacao, setDataNegativacao] = useState(item.dataNegativacao)
    const [statusNegativacao, setStatusNegativacao] = useState(item.statusNegativacao)


    const inputs = <>
        <dov className="d-flex">

            <DatePicker
                label="Data de Negativação"
                sx={{
                    width: '100%'
                }}
                value={dataNegativacao ? dayjs(dataNegativacao) : null}
                onChange={(e) => handleChangeData(e, setDataNegativacao)}
            />
            <span
                className='text-secondary'
                style={{cursor: 'pointer', margin: '2% 0'}}
                onClick={() => setDataNegativacao(null)}
                title={'Limapr Data'}
            >
                <CloseIcon fontSize='large'/>
            </span>
        </dov>

        <Select
            className="basic-single mb-4"
            classNamePrefix="select"
            id="form_select"
            required={true}
            defaultValue={statusNegativacaoList.filter(item => item.value === statusNegativacao)}
            isDisabled={false}
            isLoading={false}
            isClearable={false}
            isRtl={false}
            isSearchable={true}
            options={statusNegativacaoList}
            onChange={(e) => setStatusNegativacao(e.value)}
            placeholder={'Status *'}
        />
    </>

    const icon = <PersonIcon fontSize="large" id="icon-svg"/>
    const buttonText = <span>
        <DriveFileRenameOutlineIcon fontSize="medium"/> &nbsp;
        Editar Dados de Negativação
    </span>

    const itemToState = () => {
    }

    const returnData = () => {
        return {
            dataNegativacao,
            statusNegativacao
        }
    }

    return <PopupEdit
        baseUrl={baseUrl + `/${item.id}`} setLoadData={setLoadData}
        inputs={inputs} title={'Editar Dados de Negativação'} icon={icon}
        returnData={returnData} itemToState={itemToState}
        setErrorMessage={() => {
        }} setErrorColumn={() => {
    }}
        buttonText={buttonText} buttonClass='dropdown-item'
    />
}